import { useEffect, useState, useRef } from "react";

export type IOptions = NotificationOptions & {
  onClose?: (this: Notification, ev: Event) => void;
  onClick?: (this: Notification, ev: Event) => void;
  onError?: (this: Notification, ev: Event) => void;
  onShow?: (this: Notification, ev: Event) => void;
};

const isSupported = "Notification" in window;

const useNotification = () => {
  const Notification = isSupported ? window.Notification : null;
  const [isPermissionGranted, setIsPermissionGranted] = useState<boolean>(
    Notification?.permission === "granted"
  );

  let notification = useRef<ServiceWorkerRegistration | null>(null);

  const notify = (
    title: string | null | undefined,
    options: IOptions,
    showOnHidden = true
  ) => {
    if (!title || !Notification || !isPermissionGranted) return;

    if (showOnHidden) {
      document.hidden && new Notification(title, options);
    } else {
      new Notification(title, options);
    }
  };

  const close = () => {
    // notification.current?.close();
  };

  useEffect(() => {
    if (!isPermissionGranted) {
      Notification?.requestPermission().then((status) =>
        setIsPermissionGranted(status === "granted")
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermissionGranted, notification]);

  return {
    notify,
    close,
  };
};

export default useNotification;
